import PropTypes from 'prop-types'
import React from 'react'
import ImageProvider from './ImageProvider'

const WORK = [
  { id: 'unternehmensentwicklung', name: 'Unternehmensentwicklung' },
  { id: 'leadership', name: 'Leadership' },
  { id: 'teamentwicklung', name: 'Teamentwicklung' },
  { id: 'supervision', name: 'Supervision' },
]

function OtherWork(props) {
  return (
    <div className="work-menu-other">
      <strong>{props.headline ?? 'Weitere Angebote:'}</strong>
      <ul>
        {WORK.filter(work => work.id !== props.article).map(work => (
          <li key={work.id}>
            <a
              href={`#${work.id}`}
              onClick={() => {
                props.goto(work.id)
              }}
            >
              {work.name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

class Main extends React.Component {
  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      ></div>
    )

    this.goto = article => {
      setTimeout(() => {
        this.props.handleOpenArticle('')
        this.props.handleOpenArticle(article)
        document.body.scrollIntoView({
          behavior: 'smooth',
        })
      }, 200)
    }

    return (
      <div
        ref={this.props.setWrapperRef}
        id="main"
        style={this.props.timeout ? { display: 'flex' } : { display: 'none' }}
      >
        <article
          id="intro"
          className={`${this.props.article === 'intro' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Intro</h2>
          <span className="image main">
            <ImageProvider
              fileName="markus-spiske-nFni-3zOaXg-unsplash.jpg"
              style={{ width: '100%' }}
              alt="Photo by Markus Spiske on Unsplash"
            />
          </span>

          <p>
            Ich begleite Menschen und Organisationen in Entwicklungsprozessen –
            mit Klarheit, Tiefe und langjähriger Erfahrung. Gemeinsam Räume
            schaffen, in denen Reflexion, Veränderung und Wachstum möglich
            werden.
          </p>
          <p>
            {OtherWork({
              article: this.props.article,
              goto: this.goto,
              headline: 'Mein Fokus:',
            })}
          </p>

          <p>
            Veränderung wirksam gestalten – mit Klarheit, Tiefe und Struktur Ob
            Ihr Unternehmen wächst, sich neu ausrichtet oder festgefahren
            scheint: Veränderung betrifft immer mehr als Prozesse – sie betrifft
            Menschen. In jeder Organisation wirken Strategie, Struktur und
            Kultur zusammen. Genau hier setze ich an.
          </p>

          <p>
            Als erfahrene Coachin, Organisationsentwicklerin und
            Prozessbegleiterin unterstütze ich Sie dabei, Wandel nicht nur zu
            managen, sondern ihn sinnvoll zu gestalten – mit Klarheit, Empathie
            und einem wachen Blick von außen. Ich begleite Führungskräfte, Teams
            und Organisationen durch herausfordernde Phasen: methodensicher,
            aufmerksam und mit einem tiefen Verständnis für systemische
            Zusammenhänge. Von der ersten Idee über die durchdachte Konzeption
            bis zur konsequenten Umsetzung. Damit aus Veränderung echte
            Entwicklung wird – und Ihre Organisation gewinnt.
          </p>

          <div>
            <ProfileDownload />
          </div>
          <br />
          <a
            className="button"
            href={`#work`}
            onClick={() => {
              this.goto('work')
            }}
          >
            Erfahren Sie mehr über meine Arbeit
          </a>
          {close}
        </article>

        <article
          id="work"
          className={`${this.props.article === 'work' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Work</h2>

          <p>
            Ob in der Unternehmens- oder Teamentwicklung, im Bereich Leadership
            oder in der Supervision: Meine Leistungen zielen darauf ab, Haltung
            mit Wirkung zu verbinden und nachhaltige Veränderung zu ermöglichen.
            Informieren Sie sich über die einzelnen Angebote – und finden Sie
            den passenden Impuls für Ihre Organisation.
          </p>

          <ul className="work-menu">
            {WORK.map(work => (
              <li key={work.id}>
                <a
                  href={`#${work.id}`}
                  onClick={() => {
                    this.goto(work.id)
                  }}
                >
                  {work.name}
                </a>
              </li>
            ))}
          </ul>

          {close}
        </article>

        <article
          id="unternehmensentwicklung"
          className={`${
            this.props.article === 'unternehmensentwicklung' ? 'active' : ''
          } ${this.props.articleTimeout ? 'timeout' : ''}`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Unternehmensentwicklung</h2>
          <h3>mit Haltung – und Wirkung.</h3>
          <span className="image main">
            <ImageProvider
              fileName="eden-constantino-OXmym9cuaEY-unsplash.jpg"
              style={{ width: '100%' }}
              alt="Foto von Eden Constantino auf Unsplash"
            />
          </span>
          <p>
            Ich begleite Unternehmen dabei, sich strukturell, kulturell und
            strategisch weiterzuentwickeln. Gemeinsam gestalten wir
            Veränderungen, die nicht nur auf dem Papier funktionieren, sondern
            im Alltag gelebt werden. Ob neue Führungslogiken, agile Teams oder
            der Wandel hin zu mehr Selbstverantwortung – ich unterstütze mit
            einem systemischen Blick, einer klaren Methodik und einem echten
            Gespür für Dynamiken und Menschen.
          </p>
          <p>
            <strong>Typische Anliegen meiner Kund:innen:</strong>
            <ul>
              <li>Veränderungen strategisch und partizipativ gestalten</li>
              <li>Team- oder Bereichsstrukturen neu ausrichten</li>
              <li>Führungskräfte auf Veränderungsprozesse vorbereiten</li>
              <li>Zusammenarbeit über Hierarchien und Silos hinweg stärken</li>
            </ul>
          </p>
          <p>
            Ich begleite Unternehmen in Entwicklungsprozessen – mit Klarheit,
            Tiefe und langjähriger Erfahrung, um gemeinsame{' '}
            <strong>
              Räume zu schaffen, in denen Reflexion, Veränderung und Wachstum
            </strong>{' '}
            möglich werden.
          </p>
          <p>
            <strong>Meine Rolle:</strong> Impulsgeberin, Prozessarchitektin,
            Sparringspartnerin – immer mit dem Ziel, dass Ihre Organisation
            langfristig selbst handlungsfähig bleibt.
          </p>

          {OtherWork({ article: this.props.article, goto: this.goto })}

          {close}
        </article>

        <article
          id="leadership"
          className={`${this.props.article === 'leadership' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Leadership</h2>
          <h3> neu denken – und wirksam gestalten.</h3>
          <span className="image main">
            <ImageProvider
              fileName="manas-rb-7ldxC_OfkCM-unsplash.jpg"
              style={{ width: '100%' }}
              alt="Foto von manas rb auf Unsplash"
            />
          </span>
          <p>
            Ich begleite Führungskräfte dabei, ihre Rolle klarer zu definieren,
            ihre Wirksamkeit zu stärken und in herausfordernden Kontexten sicher
            zu agieren. Dabei geht es nicht nur um Tools und Modelle – sondern
            um Haltung, Selbstreflexion und echtes Führungsverhalten im Alltag.
          </p>
          <p>
            Ob erfahrene Führungskraft oder neue Rolle – mein Ansatz verbindet
            Praxisnähe mit Tiefe und Raum für Entwicklung.
          </p>
          <p>
            <strong>Typische Anliegen meiner Kund:innen:</strong>
            <ul>
              <li>Rollenklärung in der Führung</li>
              <li>Einstieg in Führungsverantwortung</li>
              <li>Führung in Veränderungsprozessen</li>
              <li>Aktives Stakeholdermanagement </li>
              <li>Stärkung von Selbstführung und Entscheidungsfähigkeit</li>
              <li>Aufbau von Feedback- und Vertrauenskultur</li>
              <li>Konflikte verstehen und wirksam agieren</li>
            </ul>
          </p>
          <p>
            Ziel ist eine Führung, die{' '}
            <strong>klar, verbindlich und menschlich</strong> agiert – und in
            ihrer Organisation Vertrauen und Orientierung schafft.
          </p>
          <p>
            <strong>Formate:</strong> Einzelcoachings,
            Entwicklungsprogramme/Workshopreihen, kollegiale Lernräume,
            Führungsklausuren
          </p>
          <p>
            <strong>Meine Rollen in der Führungskräfteentwicklung:</strong>{' '}
            Prozessbegleiterin, die Entwicklungsräume gestaltet, Coach, die
            Reflexion ermöglicht und Haltung stärkt, Impulsgeberin, die
            Perspektiven eröffnet, Sparringspartnerin, die ehrlich, klar und
            wertschätzend ist
          </p>

          {OtherWork({ article: this.props.article, goto: this.goto })}

          {close}
        </article>

        <article
          id="teamentwicklung"
          className={`${
            this.props.article === 'teamentwicklung' ? 'active' : ''
          } ${this.props.articleTimeout ? 'timeout' : ''}`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Teamentwicklung</h2>
          <h3>Zusammenarbeit stärken, Vertrauen fördern</h3>
          <span className="image main">
            <ImageProvider
              fileName="nick-fewings-ORSkFfgfEBI-unsplash.jpg"
              style={{ width: '100%' }}
              alt="Foto von Nick Fewings auf Unsplash"
            />
          </span>
          <p>
            Ich begleite Teams in Phasen von Wachstum, Umbruch oder Reibung -
            und schaffe Räume, in denen offen gesprochen, klar ausgerichtet und
            konstruktiv zusammengearbeitet werden kann.
          </p>
          <p>
            Ob erfahrene Führungskraft oder neue Rolle – mein Ansatz verbindet
            Praxisnähe mit Tiefe und Raum für Entwicklung.
          </p>
          <p>
            <strong>Typische Anliegen meiner Kund:innen:</strong>
            <ul>
              <li>Rollenklärung, Schnittstellen, Zuständigkeiten</li>
              <li>Spannungen, Konflikte oder Dysfunktionen</li>
              <li>Neue Führung, Teamentwicklung nach Umstrukturierung</li>
              <li>
                Teamziele, Werte und Kommunikation auf den Prüfstand stellen
              </li>
            </ul>
          </p>
          <p>
            Ziel ist es die Zusammenarbeit in einem Team so zu gestalten, dass{' '}
            <strong>
              Vertrauen, Klarheit, Wirksamkeit und gemeinsame Verantwortung
            </strong>{' '}
            gestärkt werden – damit das Team sein volles Potenzial entfalten und
            nachhaltig zum Erfolg des Unternehmens beitragen kann.
          </p>
          <p>
            Nach einer Teamentwicklung ist der Veränderungsprozess oft noch
            nicht abgeschlossen – er beginnt im Alltag. Die{' '}
            <strong>Teamsupervision</strong> schafft einen geschützten Raum, um
            neue Muster zu festigen, offene Themen zu klären und das Team dabei
            zu unterstützen, Verantwortung und Zusammenarbeit
            weiterzuentwickeln. Link zum Dokument Teamsupervision.
          </p>
          <p>
            <a
              className="button"
              href={`/Teamsupervision_zur_Sicherung_von_Teamentwicklung.pdf`}
              download
            >
              One-Pager herunterladen <small>(PDF, 83 KB)</small>
            </a>
          </p>
          <p>
            <strong>Meine Rollen in der Teamentwicklung:</strong>{' '}
            Prozessgestalterin, Moderatorin, Übersetzerin, Impulsgeberin,
            Supervisorin.
          </p>

          {OtherWork({ article: this.props.article, goto: this.goto })}

          {close}
        </article>

        <article
          id="supervision "
          className={`${this.props.article === 'supervision' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major2">
            Supervision in Ver&shy;änder&shy;ungs &shy;prozess&shy;en
          </h2>
          <h3>Reflexion, die bewegt</h3>
          <span className="image main">
            <ImageProvider
              fileName="eden-constantino-OXmym9cuaEY-unsplash.jpg"
              style={{ width: '100%' }}
              alt="Photo by Eden Constantino on Unsplash"
            />
          </span>
          <p>
            In meiner Arbeit mit Organisationen, Teams, Changebegleiter/innen
            und Führungskräften begegnet mir immer wieder ein zentrales
            Bedürfnis: ein Raum, um innezuhalten und ein Blick von Außen.{' '}
            <strong>Supervision</strong> bietet genau das – eine Möglichkeit,
            die eigene Rolle zu reflektieren, Muster zu erkennen und die
            Zusammenarbeit bewusster zu gestalten.
          </p>
          <p>
            In meiner <strong>Unternehmens-Supervision</strong> unterstütze ich
            Führungskräfte, Projektleiter und Veränderungsbegleiter:innen dabei,
            sich selbst, ihr Handeln und ihre Organisation in herausfordernden
            Prozessen klarer zu sehen – um mit mehr Bewusstheit, Wirksamkeit und
            innerer Stabilität agieren zu können.
          </p>
          <p>
            <strong>Typische Anliegen meiner Kund:innen:</strong>
            <ul>
              <li>
                intern gestalteter OE-Prozess (Reorganisation, Kulturprozesse,
                …)
              </li>
              <li>Umgang mit komplexen oder belastenden Situationen</li>
              <li>Klärung von Rollen, Aufträgen, Verantwortlichkeiten</li>
              <li>Teamdynamiken, Spannungen, Kommunikationsmuster</li>
              <li>Führung in herausfordernden Kontexten</li>
            </ul>
          </p>
          <p>
            <strong>Meine Rollen in der Supervision:</strong>{' '}
            Reflexionspartnerin, Fragenstellerin, Rahmenhalterin,
            Organisationsentwicklerin
          </p>

          <p>
            <a
              className="button"
              href={`/Supervision_in_Veraenderungsprozessen.pdf`}
              download
            >
              One-Pager herunterladen <small>(PDF, 92 KB)</small>
            </a>
          </p>

          {OtherWork({ article: this.props.article, goto: this.goto })}

          {close}
        </article>

        <article
          id="about"
          className={`${this.props.article === 'about' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">About</h2>
          <span className="image main">
            <ImageProvider
              fileName="Manuela Francke61455sw_01.jpg"
              style={{ width: '100%' }}
              alt="(c) Manuela Francke"
            />
          </span>
          <p>
            Ich bin Diplom-Sozialwissenschaftlerin und begleite seit über 25
            Jahren Menschen und Organisationen in Entwicklungsprozessen – mit
            einem besonderen Blick für das Zusammenspiel von Struktur, Kultur
            und Führung.
          </p>
          <p>
            Viele Jahre war ich als interne Beraterin und Führungskraft tätig
            und leitete eine Abteilung für Personal- und
            Organisationsentwicklung. Ich verantwortete strategische
            HR-Projekte, Fusionsprozesse und den kulturellen Wandel innerhalb
            großer Organisationen. Diese Praxiserfahrung prägt meine heutige
            Arbeit. Seit 2013 bin ich als externe Beraterin tätig und
            unterstütze branchen-übergreifend Unternehmen in
            Veränderungsprozessen – von der strategischen Neuausrichtung über
            Teamentwicklung bis zur kulturellen Transformation.
          </p>
          <h4>Was meine Kund:innen an mir schätzen?</h4>
          <p>
            Klarheit, Empathie und eine praxisnahe, lösungsorientierte
            Herangehensweise. Ich arbeite nicht nach Schema F, sondern entwickle
            individuelle Konzepte, die wirken – mit Gespür für Menschen und dem
            Blick fürs große Ganze. Ob im Konzern oder im Mittelstand: Ich
            arbeite auf Augenhöhe, mit Neugier und einem sicheren Gespür für
            Dynamiken und Potenziale.
          </p>
          <h4>Und sonst so? </h4>
          <p>
            Ich lebe mit meinem Sohn in Hamburg-Rissen. Draußen im Garten,
            unterwegs mit meinem Hund oder mit einem guten Buch in der Hand
            finde ich den nötigen Ausgleich zur Arbeit mit Menschen und
            Organisationen.
          </p>

          <h4>Mein Stil</h4>
          <p>
            <strong>Systematisch:</strong> Ich arbeite strukturiert, analytisch
            und zielorientiert – mit einem systemischen Blick auf Zusammenhänge
            und Wechselwirkungen- ohne den Menschen aus dem Blick zu verlieren.
            <br />
            <strong>Mutig:</strong> Ich stelle auch unbequeme Fragen und
            begleite meine Kund:innen durch echte Veränderung – nicht durch
            Kosmetik.
            <br />
            <strong>Empathisch:</strong> Ich höre zu, verstehe Zusammenhänge und
            gestalte tragfähige Beziehungen.
            <br />
            <strong>Standhaft:</strong> Auch in herausfordernden Situationen
            bleibe ich klar, stabil und lösungsorientiert – und behalte dabei
            stets das Ziel einer wirksamen Veränderung im Blick. iegeladen,
            zupackend
          </p>

          <div>
            <ProfileDownload />
          </div>

          {close}
        </article>

        <article
          id="contact"
          className={`${this.props.article === 'contact' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Contact</h2>
          <span className="image main">
            <ImageProvider
              fileName="adam-solomon-WHUDOzd5IYU-unsplash.jpg"
              style={{ width: '100%' }}
              alt="Photo by Adam Solomon on Unsplash"
            />
          </span>
          <h4>Lust auf ein Kennenlernen?</h4>
          <p>
            Neue Begegnungen eröffnen wertvolle Perspektiven und schaffen echten
            Mehrwert – für beide Seiten. Ich freue mich darauf, Sie und Ihr
            Unternehmen kennenzulernen, Ihre Ziele zu verstehen und gemeinsam
            wirkungsvolle Lösungen zu entwickeln. Mit frischen Ideen, fundierter
            Expertise und dem Anspruch, nachhaltige Ergebnisse zu erzielen.
          </p>
          <adress>
            <strong>Manuela Francke</strong>
            <br />
            Personal- & Organisationsentwicklung
            <br />
            Iserdal 1b
            <br />
            22559 Hamburg
            <br />
            <br />
            Phone <a href="tel:+491714069677">+491714069677</a>
            <br />
            E-Mail{' '}
            <a href="mailto:office@manuelafrancke.de">
              office@manuelafrancke.de
            </a>
            <br />
          </adress>
          <hr />

          <div>
            <ProfileDownload />
          </div>

          {close}
        </article>
      </div>
    )
  }
}

function ProfileDownload() {
  return (
    <div>
      <a className="button" href={`/Profil-Manuela_Francke.pdf`} download>
        Profil herunterladen <small>(PDF, 147 KB)</small>
      </a>
    </div>
  )
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
